import http from './http';

export function findRequestById(id, include = []) {
    return http.get(`/requests/${id}`, {
        params: { include: include.join(',') },
    });
}

export function getRequestCopySource(id) {
    return http.get(`/requests/${id}/copy-source`);
}

export function getRequestBasedOn(id) {
    return http.get(`/requests/${id}/based-on`);
}

export function findRequest(id) {
    return http.post(`/requests/view/${id}`);
}

export function getRequestHistory(id) {
    return http.get(`/requests/${id}/history`);
}

export function getRequestObservers(id) {
    return http.get(`/requests/${id}/observers`);
}

export function changeRequestService(id, request) {
    return http.patch(`/requests/${id}/service`, request);
}

export function changeRequestExecutor(id, request) {
    return http.patch(`/requests/${id}/executor`, request);
}

export function claimRequest(id) {
    return http.post(`/requests/${id}/claim`);
}

export function changeRequestPriority(id, priority) {
    return http.patch(`/requests/${id}/priority`, { priority });
}

// Связь обращений «главное → связанные» (массовая проблема). Только исполнитель или
// администратор: пользователю бэкенд отвечает 403.
export function getRelatedRequests(id) {
    return http.get(`/requests/${id}/related`);
}

export function getRelatedRequestCandidates(id, search) {
    return http.get(`/requests/${id}/related/candidates`, { params: { search } });
}

export function linkRequestToParent(id, parentRequestId) {
    return http.put(`/requests/${id}/parent`, { parentRequestId });
}

export function unlinkRequestFromParent(id) {
    return http.delete(`/requests/${id}/parent`);
}

export function changeRequestStatus(id, status, params = {}) {
    return http.patch(`/requests/${id}/status`, {
        status,
        params,
    });
}

export function addRequestComment(id, request) {
    return http.post(`/requests/${id}/comments`, request);
}

export function editRequestComment(id, commentId, newText) {
    return http.patch(`/requests/${id}/comments/${commentId}`, { text: newText });
}

export function addRequestObserver(id, request) {
    return http.post(`/requests/${id}/observers`, request);
}

export function deleteRequestObserver(id, observerId) {
    return http.delete(`/requests/${id}/observers/${observerId}`);
}

// Оборудование обращения (7-G1). Без права на инвентарь бэкенд отвечает пустым списком,
// позиции вне области просмотра в список не попадают.
export function getRequestInventoryItems(id) {
    return http.get(`/requests/${id}/inventory-items`);
}

// Привязка идемпотентна: повторная отвечает 200, а не ошибкой.
export function attachRequestInventoryItem(id, itemId) {
    return http.post(`/requests/${id}/inventory-items`, { itemId });
}

export function detachRequestInventoryItem(id, itemId) {
    return http.delete(`/requests/${id}/inventory-items/${itemId}`);
}

export function getUserGroupsFromBitrix24() {
    return http.get(`/bitrix24/user/groups`);
}

export function createTaskInBitrix24FromRequest(groupId, params) {
    return http.post(`/bitrix24/groups/${groupId}/tasks`, params);
}

export function getLastReadComment(request, lastComment) {
    return http.post(`/requests/${request.id}/mark-as-read`, { comment_id: lastComment.id });
}

export function getCities(limit = 15) {
    return http.get(`/cities`, { params: { limit } });
}
